import { Injectable } from '@angular/core';
import { Message } from 'primeng/primeng';
import { Subject } from 'rxjs';

/**
 * ng-packagræå»ºçé®é¢, æprimengä¸­messageServiceçæºç copyäºä¸ä»½
 */
@Injectable()
export class MessageService {

  private messageSource = new Subject<Message | Message[]>();

  messageObserver = this.messageSource.asObservable();

  add(message: Message) {
    if (message) {
      this.messageSource.next(message);
    }
  }

  addAll(messages: Message[]) {
    if (messages && messages.length) {
      this.messageSource.next(messages);
    }
  }

  clear() {
    this.messageSource.next(null);
  }
}
